import { AfterViewInit, ChangeDetectorRef, Directive, DoCheck, ElementRef, HostBinding, HostListener, inject, input, signal } from '@angular/core';
import { NgModel } from '@angular/forms';

import { InputSize } from './input.model';

@Directive({
	standalone: true,
	selector: 'input[slInput]'
})
export class InputDirective implements DoCheck, AfterViewInit {

	readonly size = input<InputSize>(InputSize.Auto);

	public el: ElementRef = inject(ElementRef);
	public ngModel: NgModel = inject(NgModel, { optional: true });
	public cd: ChangeDetectorRef = inject(ChangeDetectorRef);

	@HostBinding('class') get inputClasses(): string[] {
		return [
			'sl-input',
			'sl-input--' + this.size()
		];
	}

	@HostListener('input', ['$event'])
	onInput(event: InputEvent): void {
		this.updateState();
	}

	ngAfterViewInit(): void {
		this.updateState();
		this.cd.detectChanges();
	}

	ngDoCheck(): void {
		this.updateState();
	}

	updateState(): void {
		// future implementation if needed
	}
}
